/** A block heading row's height — room for its edit-mode control (a small button or
 *  picker), reserved in view mode too (Zero-Re-Layout). */
export const HEADING_ROW_PX = 40;
